import { Hint } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import i18n from 'modules/core/lib/i18n'

interface IAddCommentsHintProps {
  stepNumber: number
}

const AddCommentsHint = ({ stepNumber }: IAddCommentsHintProps) => {
  return (
    <Hint.Popover
      step={stepNumber}
      title={i18n.t('project_management.my_projects.hints.add_comments.title')}
      description={i18n.t('project_management.my_projects.hints.add_comments.description')}
      actionLabel={i18n.t('project_management.my_projects.hints.add_comments.action_label')}
      position="bottom right"
    />
  )
}

export default observer(AddCommentsHint)
